// src/features/admin/AdminGuard.tsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { meWithRoles } from "@/lib/api";

const NEED = new Set(["ADMIN", "SUPER_ADMIN", "AUTHOR", "MONITORING"]);

type AdminCtx = { roles: string[]; userId: number | null };
const AdminContext = createContext<AdminCtx>({ roles: [], userId: null });
export const useAdminRole = () => useContext(AdminContext);

export default function AdminGuard() {
    const [state, setState] = useState<"loading" | "ok" | "deny">("loading");
    const [roles, setRoles] = useState<string[]>([]);
    const [userId, setUserId] = useState<number | null>(null);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const data = await meWithRoles();
                const r: string[] = (data?.roles || []).map((r: any) => r.code || r);
                if (r.some((x) => NEED.has(x))) {
                    if (alive) { setRoles(r); setUserId(data?.user?.id ?? null); setState("ok"); }
                } else {
                    if (alive) setState("deny");
                }
            } catch {
                if (alive) setState("deny");
            }
        })();
        return () => { alive = false; };
    }, []);

    if (state === "loading") return <div style={{ padding: 24 }}>확인 중…</div>;
    if (state === "deny") return <Navigate to="/admin/login" replace />;
    return (
        <AdminContext.Provider value={{ roles, userId }}>
            <Outlet />
        </AdminContext.Provider>
    );
}